module.exports = __webpack_public_path__ + "img/icn_check_touhatsu.04656488.png";